import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, Stack,} from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types';

function CantidadDialog(props) {
    const { onClose, selectedValue, nombreProductoState, open } = props;

    const handleClose = () => {
        onClose(selectedValue);
    };

    const handleListItemClick = (value) => {
        onClose(value);
    };

    //Valores que se mostrarán en el dialogo como botones para elegir la cantidad deseada
    const valores = [[1, 2, 3, 4, 5], [, 6, 7, 8, 9, 10], [12, 14, 16, 18, 24]];

    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle>{nombreProductoState}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">Ingrese la cantidad:</DialogContentText>

                {valores.map((fila, i) => (
                    <Stack key={'snum_' + i} direction='row' spacing={1} padding={2}>
                        {fila.map((tecla, j) => (
                            <Button key={'bnum_' + i + j} variant="contained" onClick={() => handleListItemClick(tecla)} size="large">{tecla}</Button>
                        ))}
                    </Stack>
                ))}
            </DialogContent>
        </Dialog>
    );
}

CantidadDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    //selectedValue: PropTypes.string.isRequired,
};

export default CantidadDialog
